import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from 'react-icons/md';
import { SheetDefaults } from '../../../constants/sheetDefaults';
import { OnResizerMouseDown } from '../../../hooks/useGridResizer';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { Flex } from '@chakra-ui/react';
import { IconType } from 'react-icons/lib';
import { GridEntity, IRange } from '../../../types';
import { SheetCommandType } from '../../../types/commands/sheetCommands/sheetCommands';
import { useAppDispatch } from '../../../../core/hooks/storeHooks';
import { handleSheetOperations } from '../../../redux/sagas/root/rootActions';
import { ColumnCellView } from '../../../helpers/cellView/cellViewTypes';

interface ColResizerProps
  extends Pick<UseSheetTheme, 'selectionBorder' | 'stroke' | 'isRtl'>,
    ColumnCellView {
  linePos: number;
  gridX: number;

  sheetId: string;

  gridWidth: number;
  lineSize: number;

  colHeaderHeight: number;
  edgePos: number;
  // groupBarHeight: number;

  zoom: number;

  onResizerMouseDown: OnResizerMouseDown;
}
const ColumnResizer: React.FC<ColResizerProps> = ({
  sheetId,

  gridX,
  gridWidth,
  // groupBarHeight,
  colHeaderHeight,
  lineSize,
  linePos,
  selectionBorder,
  isRtl,

  edgePos,

  x,
  width,
  ci: colIndex,
  stroke,

  hiddenColumns,

  // hiddenColRange,
  // isColHiddenRangeBetweenFreeze,
  // previousHiddenColRange,
  // nextHiddenColRange,

  zoom,

  // isPreviousColHidden,
  // isNextColHidden,

  onResizerMouseDown,
}) => {
  const {
    hiddenRange: hiddenColRange,
    previousHiddenRange: previousHiddenColRange,
    nextHiddenRange: nextHiddenColRange,
  } = hiddenColumns ?? {};

  const dispatch = useAppDispatch();
  const unHideIconSize = SheetDefaults.unHideIconSize * zoom;
  const lineHalf = lineSize / 2;
  const startMouseDown = (e: React.MouseEvent) =>
    onResizerMouseDown(
      e,
      isRtl ? x + width - lineHalf : x - lineHalf, // Min
      isRtl ? gridX : gridX + gridWidth - lineSize, // Max
      linePos,
      colIndex,
      'column'
    );

  const handleUnhide = (range: IRange) =>
    dispatch(
      handleSheetOperations({
        type: SheetCommandType.UnhideGrid,
        ranges: [range],
        sheetId,
        entity: GridEntity.Column,
      })
    );

  //   const leftUnHideX = isRtl ? x + width - unHideIconSize : x;
  const verticalCenterPos = colHeaderHeight / 2 - unHideIconSize / 2; // groupBarHeight +

  let hiddenContainerWidth = unHideIconSize * 2;
  // if (isColHiddenRangeBetweenFreeze) {
  //   hiddenContainerWidth += SheetDefaults.freezeBarHandleSize * zoom;
  // }

  const generalStyles = {
    top: `${verticalCenterPos}px`,
    height: `${unHideIconSize}px`,
    width: `${unHideIconSize}px`,
    background: stroke,
  };

  const directionIcon = (Icon: IconType) => (
    <Flex
      // style={{ width: `${unHideIconSize}px` }}
      style={{ height: '100%', width: `${unHideIconSize}px` }}
      align="center"
      justify="center"
    >
      <Icon />
    </Flex>
  );

  const unHideButtons = () =>
    hiddenColRange && (
      <div
        style={{
          ...generalStyles,
          width: `${hiddenContainerWidth}px`,
          left: `${edgePos - hiddenContainerWidth / 2}px`,
          borderRadius: '3px',
        }}
        className="unhide-container"
        onClick={() => handleUnhide(hiddenColRange)}
      >
        {directionIcon(
          isRtl ? MdOutlineKeyboardArrowRight : MdOutlineKeyboardArrowLeft
        )}
        {directionIcon(
          isRtl ? MdOutlineKeyboardArrowLeft : MdOutlineKeyboardArrowRight
        )}
      </div>
    );

  const unHideLeftButton = () =>
    leftHidden && (
      <div
        style={{
          ...generalStyles,
          left: `${x}px`,
          borderTopRightRadius: '3px',
          borderBottomRightRadius: '3px',
        }}
        className="unhide-container"
        onClick={() => handleUnhide(leftHidden)}
      >
        {directionIcon(MdOutlineKeyboardArrowRight)}
      </div>
    );

  const unHideRightButton = () =>
    rightHidden && (
      <div
        style={{
          left: `${x + width - unHideIconSize}px`,
          ...generalStyles,
          borderTopLeftRadius: '3px',
          borderBottomLeftRadius: '3px',
        }}
        className="unhide-container"
        onClick={() => handleUnhide(rightHidden)}
      >
        {directionIcon(MdOutlineKeyboardArrowLeft)}
      </div>
    );

  const leftHidden = isRtl ? nextHiddenColRange : previousHiddenColRange;
  const rightHidden = isRtl ? previousHiddenColRange : nextHiddenColRange;

  return (
    <div>
      {unHideLeftButton()}
      {!hiddenColRange && unHideRightButton()}
      {unHideButtons()}
      <div
        style={{
          position: 'absolute',
          top: `${0}px`, // groupBarHeight
          left: `${linePos}px`,
          width: `${lineSize}px`,
          backgroundColor: selectionBorder,
          height: `${colHeaderHeight}px`,
          cursor: 'col-resize',
          zIndex: 3,
        }}
        className="resizer-hidden-line"
        onMouseDown={startMouseDown}
      />
    </div>
  );
};

export default ColumnResizer;
